package com.eladfinish.bible.contest.features.deeplink

import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val deepLinkModule = module {
    singleOf(::DeepLinkHandler)
}
